import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message } from 'view-design';

const state = {
  ...restful.states('setting')
}

const getters = {
  ...restful.getters('setting')
}

const actions = {
  ...restful.actions('settings'),
  async display ({ commit }) {
    const res = await axios.get('settings/display')
    commit('setting', res.data)
  },
  async upgrade ({ commit }, params) {
    const res = await axios.post('settings/upgrade', params)
    commit('setting', res.data)
    Message.success(i18n.t('store_modules_delivery_setting_1328'));
  }
}

const mutations = {
  ...restful.mutations('setting'),
  setting (state, setting) {
    state.setting = setting
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
